export default __webpack_public_path__ + "static/media/151-electric-1.af18e12e.png";